import { api, ENDPOINTS } from '../config';
import { CreateProfileParams, ProfilesFilters, ProfilesResponse, ProfilesResponseData } from './types';

/**
 * Fetch devices with optional filters
 */
export async function getProfiles(filters?: ProfilesFilters): Promise<ProfilesResponseData[]> {
  const response = await api.get<ProfilesResponse>(ENDPOINTS.PROFILES, {
    params: filters,
  });
  
  return response.data;
}

export async function createProfile(params: CreateProfileParams): Promise<ProfilesResponseData> {
  const response = await api.post<ProfilesResponse>(ENDPOINTS.PROFILES, {
    ...params,
  });
  
  return response.data;
}

export async function editProfile(id: string, params: CreateProfileParams): Promise<ProfilesResponseData> {
  const response = await api.patch<ProfilesResponse>(`${ENDPOINTS.PROFILES}${id}/`, {
    ...params,
  });
  
  return response.data;
}

export async function duplicateProfile(id: string): Promise<ProfilesResponseData> {
  const response = await api.post<ProfilesResponse>(`${ENDPOINTS.PROFILES}${id}/duplicate/`);
  
  return response.data;
}

export async function deleteProfile(id: string): Promise<ProfilesResponseData> {
  const response = await api.delete<ProfilesResponse>(`${ENDPOINTS.PROFILES}${id}/`);
  
  return response.data;
}